export default {
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'home',
  'menu.Project': 'Project',
  'menu.Project.Personal Project': 'Personal Project',
  'menu.Project.All Project': 'All Project',
  'menu.Project.Public Project': 'Public Project',
  'menu.Project.Authorized Project': 'Authorized Project',
  'menu.Project.authListfileList': 'Authorized Project Files',
  'menu.Project.authListfileListEdit': 'Authorized File Edit',
  'menu.Project.publicListfileListEdit': 'Public File Edit',
  'menu.Project.allListfileList': 'All Project Files',
  'menu.Project.allListfileListEdit': 'All File Edit',
  'menu.Project.fileList': 'Project Files',
  'menu.Project.fileListEdit': 'Edit Project File',
  'menu.Project.generate': 'Generate Report',
  'menu.Standard': 'Standard',
  'menu.StandardSub': 'Standard Subfolder',
  'menu.standardFile': 'Standard File',
  'menu.standardFileEdit': 'Edit Standard File',
  'menu.knowledgeFileList': 'Knowledge File List',
  'menu.Template': 'Template',
  'menu.templateSubFolder': 'Template Subfolder',
  'menu.template': 'Template',
  'menu.templateEdit': 'Edit Template',
  'menu.templateKnowledge': 'Template Knowledge',
  'menu.templateTree': 'Template Tree',
  'menu.Console': 'Console',
  'menu.Console.User Management': 'User Management',
  'menu.Console.Role Management': 'Role Management',
  'menu.Console.cost center Management': 'Cost Center Management',
  'menu.Console.Q-Matrix Management': 'Q-Matrix Management',
  'menu.Console.Parameter Management': 'Parameter Management',
  'menu.Console.Recycle': 'Recycle',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
};
